import React from 'react';
import categories from '../data/categories_update';
import { Box, Typography, Grid, Paper, Button, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();

  const handleViewProducts = (category) => {
    navigate(`/products?category=${encodeURIComponent(category)}`);
  };

  return (
    <Box sx={{ p: { xs: 1, sm: 2 } }}>
      {/* Hero Section */}
      <Box sx={{ textAlign: 'center', py: { xs: 3, sm: 6 }, background: 'linear-gradient(90deg, #2193b0 0%, #6dd5ed 100%)', color: 'white', borderRadius: 2, mb: 4 }}>
        <Typography variant="h3" gutterBottom fontWeight={700} sx={{ fontSize: { xs: '2rem', sm: '3rem' } }}>Aqeus Healthcare</Typography>
        <Typography variant="h5" gutterBottom sx={{ fontSize: { xs: '1.1rem', sm: '1.5rem' } }}>Connecting communities through quality medication</Typography>
        <Typography variant="body1" sx={{ maxWidth: 600, mx: 'auto', mb: 3, fontSize: { xs: '0.95rem', sm: '1.1rem' } }}>
          Aqeus Healthcare is a fast-growing ISO-certified pharmaceutical company with a wide network across India, supplying various government, semi-government, and institutional organizations. We deliver affordable and accessible medication to satisfy urgent medical needs.
        </Typography>
        {/* <Button variant="contained" color="primary" size="large" sx={{ fontSize: { xs: '0.95rem', sm: '1.1rem' } }}>Know More</Button> */}
      </Box>

      {/* Categories Section */}
      <Typography variant="h4" gutterBottom align="center" sx={{ fontSize: { xs: '1.3rem', sm: '2rem' } }}>Our Categories</Typography>
      <Grid container spacing={{ xs: 2, sm: 3 }} sx={{ mb: 6 }}>
        {categories.map((cat) => (
          <Grid item xs={12} sm={6} md={4} key={cat.name}>
            <Paper elevation={3} sx={{ p: { xs: 2, sm: 3 }, textAlign: 'center', minHeight: { xs: 120, sm: 180 } }}>
              <Box sx={{ mb: 2 }}>
                <img 
                  src={cat.icon} 
                  alt={cat.name}
                  style={{ 
                    width: '64px', 
                    height: '64px', 
                    objectFit: 'contain' 
                  }}
                />
              </Box>
              <Typography variant="h6" fontWeight={600} sx={{ fontSize: { xs: '1.1rem', sm: '1.25rem' } }}>{cat.name}</Typography>
              <Typography variant="body2" sx={{ fontSize: { xs: '0.95rem', sm: '1rem' } }}>{cat.description}</Typography>
              <Button variant="outlined" sx={{ mt: 2, fontSize: { xs: '0.95rem', sm: '1rem' } }} onClick={() => handleViewProducts(cat.name)}>
                View Products
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Divider sx={{ my: 4 }} />

      {/* Why Choose Us Section */}
      <Typography variant="h4" gutterBottom align="center">Why Choose Us</Typography>
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} sm={6} md={3}>
          <Paper elevation={2} sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="h6" fontWeight={600}>Robust Infrastructure</Typography>
            <Typography variant="body2">Our extensive network across India ensures a strong foundation for delivering high-quality healthcare services.</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper elevation={2} sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="h6" fontWeight={600}>Customer-Centric Approach</Typography>
            <Typography variant="body2">We prioritize the needs and satisfaction of our customers, placing them at the heart of our operations.</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper elevation={2} sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="h6" fontWeight={600}>Competitive Pricing</Typography>
            <Typography variant="body2">We offer competitive and transparent pricing, ensuring that our services remain accessible without compromising on quality.</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper elevation={2} sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="h6" fontWeight={600}>Timely Delivery</Typography>
            <Typography variant="body2">We are committed to delivering our services with the utmost punctuality, respecting the time and schedules of our clients.</Typography>
          </Paper>
        </Grid>
      </Grid>

      {/* Contact/Inquiry Form Section */}
      <Divider sx={{ my: 4 }} />
      <Typography variant="h4" gutterBottom align="center">Get in touch with us!</Typography>
      <Box sx={{ maxWidth: 500, mx: 'auto', mt: 2, mb: 6, width: '100%' }}>
        <form>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <input type="text" placeholder="Name" style={{ width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', marginBottom: 16, fontSize: '1rem' }} required />
            </Grid>
            <Grid item xs={12} sm={6}>
              <input type="text" placeholder="Subject" style={{ width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', marginBottom: 16, fontSize: '1rem' }} required />
            </Grid>
            <Grid item xs={12} sm={6}>
              <input type="email" placeholder="Email" style={{ width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', marginBottom: 16, fontSize: '1rem' }} required />
            </Grid>
            <Grid item xs={12} sm={6}>
              <input type="tel" placeholder="Phone no" style={{ width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', marginBottom: 16, fontSize: '1rem' }} required />
            </Grid>
            <Grid item xs={12}>
              <textarea placeholder="Message" rows={4} style={{ width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', marginBottom: 16, fontSize: '1rem' }} required />
            </Grid>
            <Grid item xs={12}>
              <Button type="submit" variant="contained" color="primary" fullWidth sx={{ fontSize: { xs: '0.95rem', sm: '1rem' } }}>Submit</Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Box>
  );
}